module.exports = __webpack_public_path__ + "img/imgSrc44.af0f2d01.png";